import { createContext } from 'react'
import type {
  PractitionerSetup,
  SharedSetup,
  UserRole,
  WotSelection,
} from './sessionTypes'

export interface SessionContextValue {
  practitioner: PractitionerSetup
  shared: SharedSetup
  /** Name or identifier of the client for the current session */
  clientName: string
  /** Practitioner PANAS mood score 0–100, null before completing */
  panasScore: number | null
  /** Practitioner Window of Tolerance self-report */
  wotSelection: WotSelection | null
  /** Client Window of Tolerance check (captured on SessionStartPage) */
  clientWotSelection: WotSelection | null
  /** Client PANAS mood score 0–100, null before completing */
  clientPanasScore: number | null
  /** Client post-session PANAS score 0–100 */
  clientPostPanasScore: number | null
  /** True when post-session PANAS was skipped with no answers */
  postSessionPanasSkipped: boolean
  /** Practitioner session notes for the current session */
  sessionNotes: string
  /** Practitioner follow-up notes for the current session */
  followUpNotes: string
  /** Signed-in role for logout routing */
  userRole: UserRole
  setPractitioner: (update: Partial<PractitionerSetup>) => void
  setShared: (update: Partial<SharedSetup>) => void
  setClientName: (name: string) => void
  setPanasScore: (score: number) => void
  setWotSelection: (sel: WotSelection) => void
  setClientWotSelection: (sel: WotSelection) => void
  setClientPanasScore: (score: number) => void
  setClientPostPanasScore: (score: number) => void
  setPostSessionPanasSkipped: (skipped: boolean) => void
  setSessionNotes: (notes: string) => void
  setFollowUpNotes: (notes: string) => void
  setUserRole: (role: UserRole) => void
  clearSession: () => void
  isPractitionerReady: boolean
}

export const INITIAL_PRACTITIONER: PractitionerSetup = {
  relationshipType: null,
  sessionMode: null,
  moodCheckMode: 'none',
  includeWotCheck: false,
  includeWarmup: false,
}

export const INITIAL_SHARED: SharedSetup = {
  dataConsent: null,
  captureMethod: null,
}

export const SessionContext = createContext<SessionContextValue | null>(null)
